
setTimeout(function () {
    var checkoutDraftBtn = document.getElementById('checkout-draft-btn');
    var customer = document.getElementById('customerData');
    console.log("xxxxxxxxx");
    console.log(customer);

    if (checkoutDraftBtn) {
        checkoutDraftBtn.addEventListener('click', function (event) {
            newOrder();
        }, false);
    }

    //select all the buttons with class add-to-cart-row
    var addToCartButtons = document.querySelectorAll('.add-to-cart-row');

    //loop through all the buttons
    addToCartButtons.forEach(function (button) {
        //add a click event to each button
        button.addEventListener('click', function (event) {
            //get attribute data-product-id
            
            $("body").addClass("loading");

            button.classList.add("loading");
            //button.textContent = "";
            button.disabled = true;
            
            var productId = button.getAttribute('data-product-id');

            //foreach over all inputs with class qty_product_{productId}
            var qtyInputs = document.querySelectorAll('.qty_product_' + productId);
            let items = [];
            qtyInputs.forEach(function (input) {
                //get the value of the input
                var qty = input.value;

                //if the value is greater than 0
                if (qty > 0) {
                    //add the product to the cart
                    //get attribute data-variant-id
                    var variantId = input.getAttribute('data-variant-id');

                    console.log("productId: " + productId + " variantId: " + variantId + " qty: " + qty);

                    items.push({
                        id: variantId,
                        quantity: qty
                    });
                }
            });

            if (items.length > 0) {
                console.log(items);
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        items: items
                    },
                    dataType: 'json',
                    success: function (data) {
                        console.log(data);
                        
                        //Swal.fire({


                        location.reload();
                    },
                    error: function (data) {
                        console.log(data);
                        $("body").removeClass("loading");
                        Swal.fire(
                            {
                                icon: 'error',
                                title: 'Error',
                                text: 'An error has occurred, please try again later.'
                            }
                        ); 
                    }
                });
            }
        });
    });

    function newOrder() {

        $("body").addClass("loading");

        checkoutDraftBtn.classList.add("single_add_to_cart_button");
        checkoutDraftBtn.classList.add("js_frm_cart");
        checkoutDraftBtn.classList.add("loading");
        checkoutDraftBtn.textContent = "";
        checkoutDraftBtn.disabled = true;

        let customerJson = JSON.parse(customer.value);

        console.log(customerJson);

        let newItems = [];

        for(let i = 0; i < items.length; i++){
            console.log(items[i]);
            newItems.push({
                name:  items[i].title,
                quantity: parseInt(items[i].quantity),
                price: items[i].price,
                EAN: items[i].variant_sku
            });
        }

        let address = "<b>Dirección</b><br>" + customerJson.address.address1 + ' ' + customerJson.address.address2 + '<br>' + customerJson.address.city + ', ' + customerJson.address.province + '<br>' + customerJson.address.country + '<br>' + customerJson.address.zip;
        address += '<br><br><b>Teléfono</b><br>' + customerJson.address.phone;

        let wrapper = {
            email: customerJson.email,
            name: customerJson.address.first_name + ' ' + customerJson.address.last_name,
            otros: address,
            items: newItems
        };

        //post object to https://oucf5z5jgnju7mwh4iq2e45zne0fgxhd.lambda-url.us-east-2.on.aws/

        // $.ajax({
        //     type: 'POST',
        //     url: 'https://oucf5z5jgnju7mwh4iq2e45zne0fgxhd.lambda-url.us-east-2.on.aws/',
        //     data: wrapper,
        //     dataType: 'json',
        //     success: function (data) {
        //         console.log(data);
        //         //jQuery.post('/cart/clear.js',);
        //         //window.location.href = "/en/pages/thank-you";
        //     },
        //     error: function (data) {
        //         console.log(data);
        //     }
        // });

        console.log("wrapper");
        console.log(wrapper);

         const options = {
            method: 'POST',
            headers: {
              accept: 'application/json',
              'content-type': 'application/json'
            },
            body: JSON.stringify(wrapper)
          };
          
          fetch('https://oucf5z5jgnju7mwh4iq2e45zne0fgxhd.lambda-url.us-east-2.on.aws/', options)
            .then(response => response.text())
            .then(response => {
                //console.log(response);
                jQuery.post('/cart/clear.js',);
                window.location.href ="/en/pages/thank-you";
            })
            .catch(err => console.error(err));


        // let htmlMail = '<b>Nuevo Pedido</b><br>';
        // htmlMail += '<b>Cliente</b><br>';
        // //htmlMail += 'Nombre: ' + customerJson.first_name + ' ' + customerJson.last_name + '<br>';
        // htmlMail += 'Email: ' + customerJson.email + '<br><br>';

        // htmlMail += '<b>Items</b><br>';
        // htmlMail += '<table>';
        // htmlMail += '<thead>'
        // htmlMail += '<tr>';
        // htmlMail += '<th style="text-align: left">Nombre</th>';
        // htmlMail += '<th style="text-align: right">Cantidad</th>';
        // htmlMail += '<th style="text-align: right">Precio</th>';
        // htmlMail += '</tr>';
        // htmlMail += '</thead>'
        // htmlMail += '<tbody>'
        // for(let i = 0; i < items.length; i++){
        //     htmlMail += '<tr>';
        //     htmlMail += '<td>' + items[i].title + '</td>';
        //     htmlMail += '<td style="text-align: right">' + items[i].quantity + '</td>';
        //     htmlMail += '<td style="text-align: right">' + items[i].price + '</td>';
        //     htmlMail += '</tr>';
        // }

        // htmlMail += '</tbody>'
        // htmlMail += '</table>';

        // console.log(htmlMail);

        // const options = {
        //     method: 'POST',
        //     headers: {
        //       accept: 'application/json',
        //       'content-type': 'application/json',
        //       'X-API-KEY': '61e04e290748a2ff2e21f478-As6fpf7SQ0ezKQh6PgEEAhPFrvjjqgv1PERoui1bs7qgWp3i0v'
        //     },
        //     body: JSON.stringify({fields: {items: htmlMail}, email: 'gv9007@gmail.com', systemName: 'b2b_client'})
        //   };
          
        //   fetch('https://api.omnisend.com/v3/events', options)
        //     .then(response => response.text())
        //     .then(response => {
        //         jQuery.post('/cart/clear.js',);
        //         window.location.href ="/en/pages/thank-you";
        //     })
        //     .catch(err => console.error(err));


        // jQuery.getJSON('/cart.js', function (cart) {

        //     console.log(cart);

        //     var total_order = cart.total_price / 100;


        //     checkoutDraftBtn.classList.add("single_add_to_cart_button");
        //     checkoutDraftBtn.classList.add("js_frm_cart");
        //     checkoutDraftBtn.classList.add("loading");
        //     checkoutDraftBtn.textContent = "";
        //     checkoutDraftBtn.disabled = true;
        //     //checkoutDraftBtn2.disabled = true;

        //     var json = {
        //         ShopId: Shopify.shop,
        //         Cart: cart,
        //         Customer: JSON.parse(customer.value)
        //     }

        //     console.log(JSON.stringify(json));

        //     const options = {
        //         method: 'POST',
        //         headers: {
        //           accept: 'application/json',
        //           'content-type': 'application/json',
        //           'X-API-KEY': '61e04e290748a2ff2e21f478-As6fpf7SQ0ezKQh6PgEEAhPFrvjjqgv1PERoui1bs7qgWp3i0v'
        //         },
        //         body: JSON.stringify({fields: {items: '<b>Items</b><br>Prueba'}, email: 'gv9007@gmail.com', systemName: 'b2b_client'})
        //       };
              
        //       fetch('https://api.omnisend.com/v3/events', options)
        //         .then(response => response.json())
        //         .then(response => console.log(response))
        //         .catch(err => console.error(err));

        //     /*
        //     fetch(
        //       'https://shopifyhub.azurewebsites.net/api/Order/NewOrder',
        //       {
        //         method: 'POST',
        //         headers: {
        //           'Accept': 'application/json',
        //           'Content-Type': 'application/json'
        //         },
        //         body: JSON.stringify(json)
        //       }
        //     )
        //     .then(r => r.json())
        //     .then(data => {
        //       console.log("data draft");
        //       console.log(data);
        //       if(data != null && data.isDraftOrder){
        //       //if(data != null && data.isDraftOrder && data.draftOrderUrl != null && data.draftOrderUrl != ""){
        //         jQuery.post('/cart/clear.js',);
        //             window.location.href ="/pages/thank-you";
        //         }else{
        //           alert("Error")
        //       }
        //     });
        //     */


        // });
    }

    setInterval(function () {
        //$(".js__qs").removeClass("js__qs");
    }, 500)
}, 3000);